module.exports=[
  {
    "nom": "Compagnie Jamais 203",
    "annee": 1997,
    "adresse": "1 rue de la grosse pierre",
    "codepostal": 72440,
    "ville": "Bouloire",
    "mail": "contact@ciejamais203.com",
    "www": "http://www.ciejamais203.com",
    "reseaux": "Réseau JP Sarthe",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "Théâtre Épidaure",
    "creation": 1,
    "diffusion": 0,
    "diffusion_region": 89,
    "diffusion_france": 10,
    "diffusion_monde": 1,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Oui",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.973539,
      0.554081
    ]
  },
  {
    "nom": "Compagnie Théâtrale Science 89",
    "annee": 1989,
    "adresse": "1 rue Jules Bréchoir",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "info@sallevasse.fr",
    "www": "http://www.sallevasse.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "Salle Vasse",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 6,
    "diffusion_france": 4,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.2253984,
      -1.5228336
    ]
  },
  {
    "nom": "Cie A Toute Vapeur",
    "annee": 2000,
    "adresse": "10 rue du Général de Wet",
    "codepostal": 44100,
    "ville": "Nantes",
    "mail": "",
    "www": "http://www.cieatoutevapeur.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 60,
    "diffusion_france": 40,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Oui",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.202649,
      -1.592591
    ]
  },
  {
    "nom": "Cie Du Bout Du Toit",
    "annee": 2008,
    "adresse": "10 rue Jacqueline Mazé",
    "codepostal": 49130,
    "ville": "Les Ponts de Cé",
    "mail": "contact@boutdutoit.net",
    "www": "http://www.boutdutoit.n et",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 90,
    "diffusion_france": 10,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Théâtre d'ombre",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.429695,
      -0.522006
    ]
  },
  {
    "nom": "Artbiguë Cie",
    "annee": 2004,
    "adresse": "10 rue Jacqueline Mazé",
    "codepostal": 49130,
    "ville": "Les Ponts-de-Cé",
    "mail": "artbiguecie@yahoo.fr",
    "www": "https://artbigue.jimdo.com",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 99,
    "diffusion_france": 1,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.429695,
      -0.522006
    ]
  },
  {
    "nom": "Cie Spectabilis",
    "annee": 1988,
    "adresse": "10 rue Jacqueline Mazé",
    "codepostal": 49130,
    "ville": "Les Ponts-de-Cé",
    "mail": "cie.spectabilis@wanadoo.fr",
    "www": "http://www.ciespectabilis.com",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 5,
    "diffusion_region": 70,
    "diffusion_france": 30,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.429695,
      -0.522006
    ]
  },
  {
    "nom": "Piment, Langue D'Oiseau",
    "annee": 2005,
    "adresse": "10 rue Jacqueline Mazé",
    "codepostal": 49130,
    "ville": "Les Ponts-de-Cé",
    "mail": "piment.langue.doiseau@gmail.com",
    "www": "http://www.ciepiment.fr",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 3,
    "diffusion": 5,
    "diffusion_region": 102,
    "diffusion_france": 24,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.429695,
      -0.522006
    ]
  },
  {
    "nom": "Six Monstres",
    "annee": 2005,
    "adresse": "10 rue Jacqueline Mazé",
    "codepostal": 49130,
    "ville": "Les Ponts-de-Cé",
    "mail": "sixmonstres@yahoo.fr",
    "www": "http://sixmonstres.com",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Oui",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.429695,
      -0.522006
    ]
  },
  {
    "nom": "Ana Igluka - Le Thermogène",
    "annee": 2006,
    "adresse": "105 Bd Michelet",
    "codepostal": 44300,
    "ville": "Nantes",
    "mail": "info@lethermogene.net",
    "www": "http://www.anaigluka.net/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 5,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Centre socio-culturels\nFestivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2386034,
      -1.5567409
    ]
  },
  {
    "nom": "Do Mi Sol Théâtre",
    "annee": 1995,
    "adresse": "12 allée des fontaines",
    "codepostal": 72210,
    "ville": "Fillé sur Sarthe",
    "mail": "cie.metronome@gmail.com",
    "www": "http://metronome.webnode",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 6,
    "diffusion": 6,
    "diffusion_region": 50,
    "diffusion_france": 50,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Milieu scolaire\nComités d'entreprises\nMilieu associatif",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Chant",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.9043241,
      0.1234976
    ]
  },
  {
    "nom": "Filtandem",
    "annee": 2010,
    "adresse": "12 rue de la ruette",
    "codepostal": 44300,
    "ville": "Nantes",
    "mail": "",
    "www": "http://www.theatreducyclope.com/nos-creations/",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "Théâtre du Cyclope",
    "creation": 3,
    "diffusion": 3,
    "diffusion_region": 95,
    "diffusion_france": 5,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Centres de loisirs\nThéatres privés\nMaisons de quartiers",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      47.2323162,
      -1.5095437
    ]
  },
  {
    "nom": "Duozozic",
    "annee": 2010,
    "adresse": "13 bis rue du moulin",
    "codepostal": 44610,
    "ville": "Indre",
    "mail": "duozozic@gmail.com",
    "www": "http://duozozic.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 10,
    "diffusion_france": 20,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Mairies\nMilieu scolaire\nCentre de loisirs",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.1980346,
      -1.6521236
    ]
  },
  {
    "nom": "Compagnie Comptoirs Du Rêve",
    "annee": 2014,
    "adresse": "14 rue de l'arche sèche",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "contact@comptoirsdureve.fr",
    "www": "http://www.comptoirsdureve.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 3,
    "diffusion": 3,
    "diffusion_region": 60,
    "diffusion_france": 100,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Structures petite enfance",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      47.2172458,
      -1.5579999
    ]
  },
  {
    "nom": "Compagnie Za!",
    "annee": 2017,
    "adresse": "15 Quai Ernest Renaud",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "compagnie.za@gmail.com",
    "www": "http://compagnie-za.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Théâtre pour Deux Mains",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 0,
    "diffusion_france": 70,
    "diffusion_monde": 30,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2066206,
      -1.5738962
    ]
  },
  {
    "nom": "Compagnie De L'Être Ange - Joan Vince",
    "annee": 1996,
    "adresse": "16 bis rue de Veillevigne",
    "codepostal": 44140,
    "ville": "Aigrefeuille-sur-Maine",
    "mail": "joan.vince@free.fr",
    "www": "http://letreange.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Cie la Tribouille",
    "creation": 3,
    "diffusion": 3,
    "diffusion_region": 50,
    "diffusion_france": 50,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.075637,
      -1.399468
    ]
  },
  {
    "nom": "Théâtre De L'Équinoxe",
    "annee": 1993,
    "adresse": "16 rue du Docteur Coignard",
    "codepostal": 49300,
    "ville": "Cholet",
    "mail": "theatre.equinoxe@wanadoo.fr",
    "www": "http://www.theatrequinoxe.com",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Salles polyvalentes",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.063515,
      -0.876697
    ]
  },
  {
    "nom": "Les Tombés De La Lune",
    "annee": 2008,
    "adresse": "2 rue Alfred Marchand",
    "codepostal": 72400,
    "ville": "La Ferté-Bernard",
    "mail": "tombesdelalune@gmail.com",
    "www": "http://www.jerome-come.com/",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 3,
    "diffusion": 4,
    "diffusion_region": 50,
    "diffusion_france": 50,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Salon du livre",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Arts plastiques",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.1847897,
      0.6531346
    ]
  },
  {
    "nom": "Structure : Les Boites Sauvages (coopérative Oz)- Nom D'Artiste: Lulla (collectif Lullabox)",
    "annee": 2016,
    "adresse": "2 rue Pilastre",
    "codepostal": 49000,
    "ville": "Angers",
    "mail": "boitessauvages@gmail.com",
    "www": "http://www.lesboitessauvages.fr/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Coopérative Oz",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 3,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.479305,
      -0.544351
    ]
  },
  {
    "nom": "La Parenthèse / Christophe Garcia",
    "annee": 2013,
    "adresse": "20 rue d'ANtioche",
    "codepostal": 49100,
    "ville": "Angers",
    "mail": "christophe@la-parenthese.com",
    "www": "http://www.la-parenthese.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Collégiale Saint Martin à Angers\nCentre Culturel René d'Anjou à Baugé-en-Anjou",
    "creation": 3,
    "diffusion": 3,
    "diffusion_region": 20,
    "diffusion_france": 40,
    "diffusion_monde": 40,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Lieux patrimoniaux / Musées",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.4737975,
      -0.532485
    ]
  },
  {
    "nom": "Digital Samovar",
    "annee": 2010,
    "adresse": "23 bld de Chantenay - bloc 13",
    "codepostal": 44100,
    "ville": "Nantes",
    "mail": "contact@digitalsamovar.com",
    "www": "http://www.digitalsamovar.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 58,
    "diffusion_france": 42,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.199555,
      -1.589319
    ]
  },
  {
    "nom": "Kokeshi",
    "annee": 2008,
    "adresse": "23 rue du Calvaire",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "",
    "www": "http://www.compagniekokeshi.fr",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire\nScène d'Enfance - Assitej France",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 3,
    "diffusion_region": 52,
    "diffusion_france": 48,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      47.2151495,
      -1.562241
    ]
  },
  {
    "nom": "Rekupertou",
    "annee": 1999,
    "adresse": "28 av du général de Gaulle",
    "codepostal": 44310,
    "ville": "Saint-Colomban",
    "mail": "rekupertou@yahoo.fr",
    "www": "http://www.rekupertou.com/",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 50,
    "diffusion_france": 50,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.0131346,
      -1.5733935
    ]
  },
  {
    "nom": "Compagnie Loba",
    "annee": 2001,
    "adresse": "3 boulevard Daviers",
    "codepostal": 49100,
    "ville": "Angers",
    "mail": "cieloba@cieloba.org",
    "www": "http://www.cieloba.org",
    "reseaux": "PJP 49\nPlatO - Plateforme jeune public des Pays de la Loire\nScène d'Enfance - Assitej France",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Oui",
    "structure_associee": "La Maison du conte (Chevilly-Larue – 94)\nScènes de Pays dans les Mauges (Beaupréau-en-Mauges – 49)",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 15,
    "diffusion_france": 85,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Oui",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.4792425,
      -0.5604822
    ]
  },
  {
    "nom": "Hanoumat Cie",
    "annee": 1994,
    "adresse": "3 boulevard Daviers",
    "codepostal": 49100,
    "ville": "Angers",
    "mail": "administration@hanoumat.com",
    "www": "http://www.hanoumat.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "SAAS (Structures-artistes associés solidaires)",
    "creation": 2,
    "diffusion": 4,
    "diffusion_region": 40,
    "diffusion_france": 60,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Oui",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.4792425,
      -0.5604822
    ]
  },
  {
    "nom": "Cie Îlot 135",
    "annee": 2015,
    "adresse": "3 Rue Baron",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "contact@ilot135.com",
    "www": "http://www.ilot135.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 3,
    "diffusion": 4,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2112161,
      -1.5475512
    ]
  },
  {
    "nom": "Paq'La Lune",
    "annee": 1999,
    "adresse": "3, rue Eugène Thomas",
    "codepostal": 44300,
    "ville": "Nantes",
    "mail": "contact@paqlalune.fr",
    "www": "http://www.paqlalune.fr/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 7,
    "diffusion": 7,
    "diffusion_region": 90,
    "diffusion_france": 10,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire\nIME",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.2616272,
      -1.5736368
    ]
  },
  {
    "nom": "Laurent Deschamps, Cie La Tête À Toto",
    "annee": 1996,
    "adresse": "33 rue des Moulins",
    "codepostal": 44190,
    "ville": "Gétigné",
    "mail": "",
    "www": "http://www.laurentdeschamps.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 6,
    "diffusion_region": 64,
    "diffusion_france": 32,
    "diffusion_monde": 3,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu associatif",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Conte",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.0799269,
      -1.2557099
    ]
  },
  {
    "nom": "Paf Théâtre",
    "annee": 2016,
    "adresse": "35 rue de degré",
    "codepostal": 72000,
    "ville": "Le Mans",
    "mail": "paftheatre@gmail.com",
    "www": "http://paftheatre.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 75,
    "diffusion_france": 25,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu associatif\nMilieu scolaire\nFestivals",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Compagnie A Trois Branches",
    "annee": 2009,
    "adresse": "35 rue de Degré Hall B",
    "codepostal": 72000,
    "ville": "Le Mans",
    "mail": "atroisbranches@gmail.com",
    "www": "http://www.compagnieatroisbranches.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 90,
    "diffusion_france": 10,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire\nStructures petite enfance\nHôpitaux",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Perenne Compagnie",
    "annee": 1992,
    "adresse": "35 rue de degré, Hall B - appt 201",
    "codepostal": 72000,
    "ville": "Le Mans",
    "mail": "contact@perenne-cie.org",
    "www": "https://compagnieperenne.jimdo.com/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 4,
    "diffusion": 4,
    "diffusion_region": 40,
    "diffusion_france": 5,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Bibliothèques / Médiathèques",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Lecture",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Le Théâtre Du Zouave",
    "annee": 2005,
    "adresse": "35 rue de Degré, Hall B, appt 201",
    "codepostal": 72000,
    "ville": "Le Mans",
    "mail": "theatre_du_zouave@hotmail.fr",
    "www": "http://theatre-du-zouave.wix.com/compagnie",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 70,
    "diffusion_france": 30,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Milieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Les Artisans Rêveurs",
    "annee": 2010,
    "adresse": "4 rue Gaston guillemet",
    "codepostal": 85200,
    "ville": "Fontenay-le-Comte",
    "mail": "contact@lesartisansreveurs.com",
    "www": "http://www.lesartisansreveurs.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 10,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Oui",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      46.467582,
      -0.8053835
    ]
  },
  {
    "nom": "Compagnie Du Moulin À Paroles",
    "annee": 1997,
    "adresse": "40 Levée de la Divatte",
    "codepostal": 44450,
    "ville": "Saint-Julien-de-Concelles",
    "mail": "",
    "www": "",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 4,
    "diffusion_region": 50,
    "diffusion_france": 50,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Oui",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2626709,
      -1.4193216
    ]
  },
  {
    "nom": "Compagnie Pic À Son",
    "annee": 2013,
    "adresse": "6 rue de l'Arche",
    "codepostal": 72100,
    "ville": "Le Mans",
    "mail": "cie.picason@gmail.com",
    "www": "http://ciepicason.wix.com/cie-picason",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 50,
    "diffusion_france": 50,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
        48.002631,
        0.210895
    ]
  },
  {
    "nom": "Cie Al Et Les Astrolobi",
    "annee": 2008,
    "adresse": "51 rue de la bourdonnais",
    "codepostal": 44100,
    "ville": "Nantes",
    "mail": "",
    "www": "https://www.astrolobi.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 3,
    "diffusion": 6,
    "diffusion_region": 45,
    "diffusion_france": 40,
    "diffusion_monde": 15,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Dans l’espace public",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Oui",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2061576,
      -1.5827199
    ]
  },
  {
    "nom": "Lefeuvre Annie",
    "annee": 1968,
    "adresse": "52 ter rue du levant",
    "codepostal": 72000,
    "ville": "Le Mans",
    "mail": "ylefeuvre@gmail.com",
    "www": "http://www.yannicklefeuvre-conteur.fr",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Theâtre du Passeur",
    "creation": 3,
    "diffusion": 3,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Théâtre privé",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Conte",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.0091026,
      0.211138
    ]
  },
  {
    "nom": "Compagnie Les 3t",
    "annee": 2002,
    "adresse": "58 boulevard du Doyenné",
    "codepostal": 49100,
    "ville": "Angers",
    "mail": "lestroist@cegetel.net",
    "www": "http://www.compagnielestroist.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "SAAS (Structures-artistes associés solidaires)",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 84,
    "diffusion_france": 16,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Oui",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu Associatif\nChez l’habitant\nMaison de quartier\nMilieu scolaire\nLieux patrimoniaux / Musées",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.48825175,
      -0.536962030476976
    ]
  },
  {
    "nom": "Les Mauvaises Herbes",
    "annee": 2016,
    "adresse": "58 rue de l'Ermitage",
    "codepostal": 53000,
    "ville": "Laval",
    "mail": "lesmauvaisesherbes16@gmail.com",
    "www": "",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 0,
    "diffusion_region": 0,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.0775241,
      -0.7738113
    ]
  },
  {
    "nom": "Crock'Notes",
    "annee": 1995,
    "adresse": "6 Place de l'Eglise",
    "codepostal": 49125,
    "ville": "Briollay",
    "mail": "crock.notes.asso@gmail.com",
    "www": "http://laboxajac.wixsite.com/jeunepubliclaboxajac",
    "reseaux": "RAMDAM",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 15,
    "diffusion_france": 2,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      47.564311,
      -0.509945
    ]
  },
  {
    "nom": "Cirque D'Anges Heureux",
    "annee": 1998,
    "adresse": "7 rue du lavoir",
    "codepostal": 72440,
    "ville": "Tresson",
    "mail": "cirquedangesheureux@orange.fr",
    "www": "http://www.cirquedangesheureux.com",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 60,
    "diffusion_france": 40,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Oui",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Chant",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.9030698,
      0.5760695
    ]
  },
  {
    "nom": "Jalynka (karine Jarry)",
    "annee": 2015,
    "adresse": "7 rue letouze",
    "codepostal": 72100,
    "ville": "Le Mans",
    "mail": "karinja.rry@gmail.com",
    "www": "",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 1,
    "diffusion_region": 35,
    "diffusion_france": 10,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Milieu scolaire\nStructures petite enfance",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.9871238,
      0.2077613
    ]
  },
  {
    "nom": "Compagnie 4 À Corps",
    "annee": 2007,
    "adresse": "71 bd Aristide Briand Pôle associatif, n°122",
    "codepostal": 85000,
    "ville": "La Roche-sur-Yon",
    "mail": "compagnie4acorps@gmail.com",
    "www": "http://www.compagnie4acorps.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 70,
    "diffusion_france": 0,
    "diffusion_monde": 30,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      46.670675,
      -1.43186
    ]
  },
  {
    "nom": "Compagnie Grizzli",
    "annee": 1990,
    "adresse": "71 bd Aristide Briand, Pôle associatif, n°67",
    "codepostal": 85000,
    "ville": "La Roche-sur-Yon",
    "mail": "theatre.grizzli@wanadoo.fr",
    "www": "http://www.theatre-grizzli.fr/",
    "reseaux": "Scène d'Enfance - Assitej France",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Milieu associatif",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      46.670675,
      -1.43186
    ]
  },
  {
    "nom": "Pirate",
    "annee": 1988,
    "adresse": "71 bd Aristide Briand",
    "codepostal": 85000,
    "ville": "La Roche-sur-Yon",
    "mail": "compagnie.pirate@gmail.com",
    "www": "http://www.compagnie.pirate.fr",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 38,
    "diffusion_france": 62,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Arts plastiques",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      46.670476,
      -1.4318640094277
    ]
  },
  {
    "nom": "Hellet Ludovic",
    "annee": 2010,
    "adresse": "8 rue du granit",
    "codepostal": 85170,
    "ville": "Saint-Denis-la-Chevasse",
    "mail": "ludo.hellet@hotmail.fr",
    "www": "",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 4,
    "diffusion": 2,
    "diffusion_region": 60,
    "diffusion_france": 35,
    "diffusion_monde": 5,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Chez l’habitant\nMilieu associatif",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      46.8242664,
      -1.3546346
    ]
  },
  {
    "nom": "Ludovic Hellet",
    "annee": 2009,
    "adresse": "8 rue du granit",
    "codepostal": 85170,
    "ville": "Saint-Denis-la-Chevasse",
    "mail": "ludo.hellet@hotmail.fr",
    "www": "",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 80,
    "diffusion_france": 0,
    "diffusion_monde": 20,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Non",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Conte",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      46.8242664,
      -1.3546346
    ]
  },
  {
    "nom": "Niouton'Théâtre",
    "annee": 2009,
    "adresse": "Association Poisson Pilote, Bloc 13, 23 bd de Chantenay",
    "codepostal": 44100,
    "ville": "Nantes",
    "mail": "associationpoissonpilote@gmail.com",
    "www": "http://www.nioutontheatre.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Association Poisson Pilote",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Non",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.197051,
      -1.589454
    ]
  },
  {
    "nom": "Théâtre Cabines",
    "annee": 2005,
    "adresse": "Association Poisson Pilote, Bloc 13, 23 bd de Chantenay",
    "codepostal": 44100,
    "ville": "Nantes",
    "mail": "remilelong@gmail.com",
    "www": "http://www.theatrecabines.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Association Poisson Pilote",
    "creation": 2,
    "diffusion": 3,
    "diffusion_region": 91,
    "diffusion_france": 8,
    "diffusion_monde": 1,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu associatif\nMilieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.197051,
      -1.589454
    ]
  },
  {
    "nom": "Cie Lili Desastres",
    "annee": "",
    "adresse": "ATH associés / Les Fresnaies / 61-63 rue de la Paperie",
    "codepostal": 49124,
    "ville": "Saint-Barthélemy-d'Anjou",
    "mail": "diffusion.lilidesastres@gmail.com",
    "www": "",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 4,
    "diffusion_region": 22,
    "diffusion_france": 19,
    "diffusion_monde": 6,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      47.459492,
      -0.509126
    ]
  },
  {
    "nom": "T’atrium",
    "annee": 2016,
    "adresse": "Centre de rencontres rue du haut bourg",
    "codepostal": 53940,
    "ville": "Saint-Berthevin",
    "mail": "administration@tatrium.com",
    "www": "http://www.tatrium.com",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "Ville de Saint-Berthevin",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 6,
    "diffusion_france": 21,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      48.067274,
      -0.830054
    ]
  },
  {
    "nom": "Cie Tétrofort",
    "annee": 2009,
    "adresse": "Association Les Gamettes, 35 rue de Degré",
    "codepostal": 72000,
    "ville": "Le Mans",
    "mail": "tetrofort@aol.com",
    "www": "http://www.tetrofort.com",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 50,
    "diffusion_france": 50,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.0148721,
      0.1832314
    ]
  },
  {
    "nom": "Cie Isaurel",
    "annee": 2009,
    "adresse": "Domaine culturel, Saint-Lézin",
    "codepostal": 49120,
    "ville": "Chemillé-en-anjou",
    "mail": "isaurel.cie@gmail.com",
    "www": "http://www.isaurel.com",
    "reseaux": "Enfance et musique",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 35,
    "diffusion_france": 56,
    "diffusion_monde": 9,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Réseau nature / environnement",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Oui",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Non",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.2518714,
      -0.773027601298696
    ]
  },
  {
    "nom": "Les 'Mister' De L'Ouest - Julien Poilvilain",
    "annee": 2014,
    "adresse": "La Gilberdière",
    "codepostal": 49150,
    "ville": "Le Vieil Baugé",
    "mail": "",
    "www": "http://www.lesmisterdelouest.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 0,
    "diffusion_region": 7,
    "diffusion_france": 5,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.538123,
      -0.179189
    ]
  },
  {
    "nom": "La Cigale Spectacles",
    "annee": 2018,
    "adresse": "le chêne beunard",
    "codepostal": 72210,
    "ville": "Voivres-lès-le-Mans",
    "mail": "virginiepicard-lacigale@gmx.fr",
    "www": "",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "Théâtre de Chaoué",
    "creation": 2,
    "diffusion": 5,
    "diffusion_region": 98,
    "diffusion_france": 2,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Non",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Non",
    "coords": [
      47.924792,
      0.044419
    ]
  },
  {
    "nom": "Compagnie A Deux Mains",
    "annee": 1995,
    "adresse": "le pin",
    "codepostal": 85220,
    "ville": "Coëx",
    "mail": "la-caravane-magique@sfr.fr",
    "www": "http://www.la-caravane-magique.com",
    "reseaux": "",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 74,
    "diffusion_france": 25,
    "diffusion_monde": 1,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festival\nMilieu scolaire",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "Théâtre d'ombre",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      46.715912,
      -1.708393
    ]
  },
  {
    "nom": "Cie Resnonverba",
    "annee": 2011,
    "adresse": "Le SAAS la cité des associations - 58 bd du Doyenné",
    "codepostal": 49100,
    "ville": "Angers",
    "mail": "cie.r.n.v@gmail.com",
    "www": "https://ciernv.wixsite.com/resnonverba",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 2,
    "diffusion_region": 100,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Non",
    "agecible_12ans": "Oui",
    "coords": [
      47.488406,
      -0.537091
    ]
  },
  {
    "nom": "Cie T'Es Pas Mioche",
    "annee": 2014,
    "adresse": "Le Silo",
    "codepostal": 72100,
    "ville": "Le Mans",
    "mail": "tespasmioche@gmail.com",
    "www": "http://www.cietespasmioche.fr",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 20,
    "diffusion_france": 80,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "Entreprises",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.0050522,
      0.2061635
    ]
  },
  {
    "nom": "Créatures Compagnie",
    "annee": 2001,
    "adresse": "Les Beaux Manteaux Sud",
    "codepostal": 72610,
    "ville": "Fyé",
    "mail": "creatures.hj@gmail.com",
    "www": "http://cie.creatures.free.fr/",
    "reseaux": "",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Oui",
    "structure_associee": "",
    "creation": 0,
    "diffusion": 3,
    "diffusion_region": 30,
    "diffusion_france": 60,
    "diffusion_monde": 10,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Oui",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Oui",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Oui",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      48.310753,
      0.075354
    ]
  },
  {
    "nom": "Compagnie Lily",
    "annee": 2008,
    "adresse": "Mairie",
    "codepostal": 72150,
    "ville": "Saint-Vincent-du-Lorouër",
    "mail": "compagnielily@gmail.com",
    "www": "http://www.compagnie-lily.org",
    "reseaux": "PlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Oui",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 5,
    "diffusion_region": 34,
    "diffusion_france": 43,
    "diffusion_monde": 23,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Milieu scolaire\nChez l’habitant\nBibliothèques / Médiathèques",
    "formesartistiques_theatre": "Oui",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Oui",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Oui",
    "coords": [
      47.824916,
      0.487892
    ]
  },
  {
    "nom": "Bouskidou",
    "annee": 1983,
    "adresse": "Productions hirsutes - 9 rue des olivettes",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "diffusion@productionshirsutes.com",
    "www": "https://www.productionshirsutes.com/",
    "reseaux": "RAMDAM\nPlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 2,
    "diffusion": 2,
    "diffusion_region": 65,
    "diffusion_france": 35,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.212566,
      -1.549816
    ]
  },
  {
    "nom": "Chel",
    "annee": 2008,
    "adresse": "Productions hirsutes - 9 rue des olivettes",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "diffusion@productionshirsutes.com",
    "www": "https://www.productionshirsutes.com/",
    "reseaux": "RAMDAM\nPlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 75,
    "diffusion_france": 25,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.212566,
      -1.549816
    ]
  },
  {
    "nom": "M. Charly",
    "annee": 2009,
    "adresse": "Productions hirsutes - 9 rue des olivettes",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "diffusion@productionshirsutes.com",
    "www": "https://www.productionshirsutes.com/",
    "reseaux": "RAMDAM\nPlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Oui",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 0,
    "diffusion": 2,
    "diffusion_region": 66,
    "diffusion_france": 34,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "Art de rue",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.212566,
      -1.549816
    ]
  },
  {
    "nom": "Marc Tetedoie",
    "annee": 2018,
    "adresse": "Productions hirsutes - 9 rue des olivettes",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "diffusion@productionshirsutes.com",
    "www": "https://www.productionshirsutes.com/",
    "reseaux": "RAMDAM\nPlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 0,
    "diffusion_region": 0,
    "diffusion_france": 0,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Non",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Oui",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Non",
    "diffusion_reseaux_autre": "",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Oui",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Non",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.212566,
      -1.549816
    ]
  },
  {
    "nom": "Poussins Phoniques",
    "annee": 2016,
    "adresse": "Productions hirsutes - 9 rue des olivettes",
    "codepostal": 44000,
    "ville": "Nantes",
    "mail": "diffusion@productionshirsutes.com",
    "www": "https://www.productionshirsutes.com/",
    "reseaux": "RAMDAM\nPlatO - Plateforme jeune public des Pays de la Loire",
    "lieu_creation": "Non",
    "lieu_diffusion": "Non",
    "convention": "Non",
    "structure_associee": "",
    "creation": 1,
    "diffusion": 1,
    "diffusion_region": 64,
    "diffusion_france": 36,
    "diffusion_monde": 0,
    "diffusion_reseaux_sn": "Oui",
    "diffusion_reseaux_conv": "Non",
    "diffusion_reseaux_ccn": "Non",
    "diffusion_reseaux_cdn": "Non",
    "diffusion_reseaux_thm": "Oui",
    "diffusion_reseaux_epci": "Oui",
    "diffusion_reseaux_centreculturel": "Oui",
    "diffusion_reseaux_mediatheque": "Oui",
    "diffusion_reseaux_autre": "Festivals",
    "formesartistiques_theatre": "Non",
    "formesartistiques_danse": "Non",
    "formesartistiques_cirque": "Non",
    "formesartistiques_musique": "Oui",
    "formesartistiques_marionette": "Non",
    "formesartistiques_cinema": "Non",
    "formesartistiques_theatreobjet": "Non",
    "formesartistiques_autre": "",
    "agecible_0_3ans": "Non",
    "agecible_3_6ans": "Oui",
    "agecible_6_12ans": "Oui",
    "agecible_12ans": "Non",
    "coords": [
      47.212566,
      -1.549816
    ]
  }
]
